module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-titlepage title-page",
    attrs: {
      "epub:type": "titlepage",
      "id": "title-page"
    }
  }, [_c('div', {
    staticClass: "title-page-title-subtitle-block"
  }, [_c('h1', {
    staticClass: "title-page-title"
  }, [_vm._v("Trail Marked")]), _vm._v(" "), _c('h2', {
    staticClass: "title-page-subtitle"
  }, [_vm._v("Keeper of Magic Series Book 1")])]), _vm._v(" "), _c('div', {
    staticClass: "title-page-contributor-block"
  }, [_c('div', {
    staticClass: "title-page-contributor-primary-block"
  }, [_c('h2', {
    staticClass: "title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"
  }, [_c('span', {
    staticClass: "title-page-contributor-name"
  }, [_vm._v("Heather Hambel Curley")])]), _vm._v(" "), _c('h2', {
    staticClass: "title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"
  }, [_c('span', {
    staticClass: "title-page-contributor-name"
  }, [_vm._v("Rebecca Hamilton")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6536f60e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title-page.vue
// module id = 54
// module chunks = 0